import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { PaginationState } from '@tanstack/react-table';
import { format } from 'date-fns';
import { useState } from 'react';
import { QueryKey } from '@/Config/api/queryKey';
import { SourceUrlStatsDto } from '@/Domain/api/Analytics/dto/SourceUrl.dto';
import { DateRangeState } from '@/Domain/types/DateRange.types';

const toISODate = (date?: Date) => (date ? format(date, 'yyyy-MM-dd') : '');

export const useSourceUrls = (range: DateRangeState) => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  const { data, isLoading, isError } = useQuery<SourceUrlStatsDto>({
    queryKey: [
      QueryKey.analytics.sourceUrls,
      {
        start: toISODate(range.startDate),
        end: toISODate(range.endDate),
        pageIndex: pagination.pageIndex,
      },
    ],
    placeholderData: keepPreviousData,
    staleTime: 0,
  });

  return {
    data,
    isLoading,
    isError,
    pagination,
    setPagination,
  };
};
